





































































































































































































































































import { defineComponent } from "@nuxtjs/composition-api";
import { checkHttpLink, changeImage } from "~/helpers";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import { Navigation, Pagination, Scrollbar } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination, Scrollbar]);
export default defineComponent({
  name: "BannerText",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    Swiper,
    SwiperSlide,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  setup() {
    const OptionCollection = {
      slidesPerView: 1.12,
      slidesPerGroup: 1,
      spaceBetween: 4,
      centeredSlides: false,
      loop: false,
      pagination: true,
      navigation: true,
      breakpoints: {
        640: {
          slidesPerView: 2.12,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2.12,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    };
    const OptionFeatured = {
      slidesPerView: 1.6,
      slidesPerGroup: 1,
      spaceBetween: 6,
      centeredSlides: false,
      loop: false,

      navigation: true,
      scrollbar: { draggable: true },

      breakpoints: {
        640: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 3.5,
          slidesPerGroup: 3,
          spaceBetween: 12,
        },
        1440: {
          slidesPerView: 4.7,
          slidesPerGroup: 4,
          spaceBetween: 12,
        },
      },
    };
    return {
      checkHttpLink,
      changeImage,
      OptionCollection,
      OptionFeatured,
      modules: [Navigation, Scrollbar],
    };
  },
});
